import { DesilStatisticsChart } from '@/components/DesilStatisticsChart'
import { BarChart3, Home, PieChart, TrendingUp } from 'lucide-react'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export default function DesilStatisticsPage() {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
            {/* Hero Header */}
            <div className="relative bg-gradient-to-r from-emerald-600 via-green-700 to-teal-800 overflow-hidden">
                <div className="absolute inset-0 bg-black/10">
                    <div className="absolute inset-0 bg-white/5"></div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-white/5 rounded-full"></div>
                <div className="absolute bottom-0 left-0 -mb-32 -ml-32 w-64 h-64 bg-white/5 rounded-full"></div>

                <div className="relative container mx-auto px-6 py-16">
                    <div className="max-w-4xl">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm border border-white/20">
                                <PieChart className="h-8 w-8 text-white" />
                            </div>
                            <div className="flex items-center space-x-2 text-white/80 text-sm">
                                <div className="w-2 h-2 bg-white/60 rounded-full"></div>
                                <span>Dashboard</span>
                                <div className="w-2 h-2 bg-white/60 rounded-full"></div>
                                <span>Desil Kesejahteraan</span>
                            </div>
                        </div>

                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
                            Dashboard Desil Kesejahteraan
                        </h1>

                        <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-3xl">
                            Data komprehensif desil kesejahteraan masyarakat berdasarkan pencatatan terkini dari berbagai tahap dan periode
                        </p>

                        {/* Action Button */}
                        <div className="flex flex-wrap gap-4">
                            <Button
                                className="bg-white/20 hover:bg-white/30 text-white border border-white/30 backdrop-blur-sm font-semibold px-6 py-3 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
                                onClick={() => navigate('/')}
                            >
                                <Home className="h-5 w-5 mr-2" />
                                Kembali ke Beranda
                            </Button>
                            <Button
                                className="bg-white/20 hover:bg-white/30 text-white border border-white/30 backdrop-blur-sm font-semibold px-6 py-3 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
                                onClick={() => navigate('/statistics')}
                            >
                                <BarChart3 className="h-5 w-5 mr-2" />
                                Statistik Lainnya
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Area */}
            <div className="container mx-auto px-6 py-8">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                    <div className="p-8">
                        <DesilStatisticsChart />
                    </div>
                </div>
                
                {/* Information Card */}
                <div className="mt-8">
                    <Card className="bg-gradient-to-r from-emerald-50 via-green-50 to-teal-50 border border-emerald-200 shadow-lg rounded-2xl">
                        <CardContent className="p-8">
                            <div className="text-center">
                                <div className="flex items-center justify-center mb-4">
                                    <TrendingUp className="h-8 w-8 text-emerald-600 mr-3" />
                                    <h3 className="text-2xl font-bold text-gray-900">
                                        Dashboard Desil Kesejahteraan
                                    </h3>
                                </div>
                                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                                    Analisis mendalam tingkat kesejahteraan masyarakat berdasarkan klasifikasi desil dari tahap 1 hingga 4, 
                                    dengan visualisasi data yang komprehensif untuk pemahaman distribusi kesejahteraan
                                </p>
                                <div className="flex flex-wrap gap-4 justify-center">
                                    <Button 
                                        className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-xl px-6 py-3 shadow-lg font-semibold"
                                        onClick={() => navigate('/')}
                                    >
                                        <Home className="h-5 w-5 mr-2" />
                                        Kembali ke Beranda
                                    </Button>
                                    <Button 
                                        variant="outline"
                                        className="border-emerald-300 text-emerald-700 hover:bg-emerald-50 rounded-xl px-6 py-3 shadow-lg font-semibold"
                                        onClick={() => navigate('/statistics')}
                                    >
                                        <BarChart3 className="h-5 w-5 mr-2" />
                                        Lihat Statistik Lainnya
                                    </Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    )
}